import React, { useState } from 'react';
import CommonModalLayout from '../Layouts/CommonModalLayout';
import { buttonStyles, inputStyles } from '../../styles/commonStyles';
import { useTranslation } from 'react-i18next';
import { createCategoryGroup } from '../../api/categories';
import { useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';

const CreateGroupModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const [groupName, setGroupName] = useState('');
    const [groupDescription, setGroupDescription] = useState('');
    const queryClient = useQueryClient();
    const userId = useSelector(state => state.auth.user?.id);

    const handleCreate = async () => {
        try {
            await createCategoryGroup({ name: groupName, description: groupDescription });
            queryClient.invalidateQueries(['groupedCategories', userId]);
            queryClient.invalidateQueries(['categoryGroups', userId]);
            onClose();
        } catch (error) {
            console.error('Error creating group:', error);
            alert(`Error: ${error.message}`);
        }
    };

    return (
        <CommonModalLayout
            isOpen={isOpen}
            onClose={onClose}
            title={t('categories.createGroup', 'Создать группу')}
        >
            <div className="space-y-4">
                <div className="space-y-2">
                    <label htmlFor="groupName" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        {t('categories.groupName', 'Название группы')}
                    </label>
                    <input
                        type="text"
                        id="groupName"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        className={inputStyles}
                        placeholder={t('categories.groupNamePlaceholder', 'Введите название группы')}
                    />
                </div>
                <div className="space-y-2">
                    <label htmlFor="groupDescription" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        {t('categories.groupDescription', 'Описание (необязательно)')}
                    </label>
                    <textarea
                        id="groupDescription"
                        value={groupDescription}
                        onChange={(e) => setGroupDescription(e.target.value)}
                        className={inputStyles}
                        placeholder={t('categories.groupDescriptionPlaceholder', 'Описание группы')}
                        rows={4}
                    />
                </div>
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className={buttonStyles}
                    >
                        {t('common.cancel')}
                    </button>
                    <button
                        onClick={handleCreate}
                        className={buttonStyles}
                        disabled={!groupName.trim()}
                    >
                        {t('common.create')}
                    </button>
                </div>
            </div>
        </CommonModalLayout>
    );
};

export default CreateGroupModal; 